import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import Footer from '../Container/Footer/Footer'
import SEO from '../Container/SEO/SEO'
import TopNav from '../Container/TopNav/TopNav'
import Diagnosis1 from '../Container/Diagnosistreatment/Diagnosis1'
import Diagnosis2 from '../Container/Diagnosistreatment/Diagnosis2'
export default function Diagnosis() {
    return (
       
      <React.Fragment>
      <SEO title="Kalpataru || Diagnosis"  />
      <TopNav/>
      <Breadcrumb image="images/about/herb.jpg" title="Home" content="Diagnosis"/>
     <Diagnosis1/>
     <Diagnosis2/>
      <Footer/>
     </React.Fragment>

       
    )
}
